// Envoyer un lien (D-075) : le message tout prêt, à copier ou à envoyer par WhatsApp, SMS…
// Rien ne part tout seul : c'est la personne qui envoie, depuis son téléphone.
import { $, html, openSheet, toast, type Html } from './dom';

export const inviteUrl = (token: string): string => `${location.origin}/i/${token}`;
export const waHref = (text: string): string => `https://wa.me/?text=${encodeURIComponent(text)}`;

export async function copyText(text: string, field?: HTMLInputElement | HTMLTextAreaElement | null): Promise<void> {
  try { await navigator.clipboard.writeText(text); toast('Copié'); }
  catch { field?.select(); toast('Sélectionné : copie-le'); }
}

/** Le message à envoyer, modifiable, avec Copier, WhatsApp et Partager. */
export function openShare(title: string, intro: Html | string, message: string,
  opts: { footer?: Html; setup?: (sheet: HTMLElement, close: () => void) => void; onClose?: () => void } = {}): void {
  openSheet(title, html`
    ${typeof intro === 'string' ? html`<p>${intro}</p>` : intro}
    <label class="field"><span>Message</span><textarea class="iv-msg" id="iv-msg" rows="4">${message}</textarea></label>
    <div class="btn-row">
      <a class="btn btn-primary btn-sm" id="iv-wa" href="${waHref(message)}" target="_blank" rel="noopener">WhatsApp</a>
      <button type="button" class="btn btn-ghost btn-sm" id="iv-copy">Copier</button>
      ${'share' in navigator ? html`<button type="button" class="btn btn-ghost btn-sm" id="iv-share">Partager…</button>` : ''}
    </div>
    ${opts.footer ?? ''}`, (sheet, close) => {
    const ta = $<HTMLTextAreaElement>(sheet, '#iv-msg')!;
    const wa = $<HTMLAnchorElement>(sheet, '#iv-wa')!;
    ta.addEventListener('input', () => { wa.href = waHref(ta.value); });
    $(sheet, '#iv-copy')!.addEventListener('click', () => void copyText(ta.value, ta));
    $(sheet, '#iv-share')?.addEventListener('click', () => { void navigator.share({ title, text: ta.value }).catch(() => undefined); });
    opts.setup?.(sheet, close);
  }, opts.onClose);
}

/** « il y a 3 jours », « hier », « à l'instant ». */
export function since(iso: string | null): string {
  if (!iso) return '';
  const m = Math.round((Date.now() - Date.parse(iso)) / 60000);
  if (m < 1) return 'à l’instant';
  if (m < 60) return `il y a ${m} min`;
  const h = Math.round(m / 60);
  if (h < 24) return `il y a ${h} h`;
  const d = Math.round(h / 24);
  return d === 1 ? 'hier' : `il y a ${d} jours`;
}
